var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{ref:"mainContainer",staticClass:"Vlt-main Vlt-main--dark mainAdminContainer"},[_c('UserSearchAndHistory')],1)}
var staticRenderFns = []

export { render, staticRenderFns }